import services from './../../../services/service'; // Service Class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer
import Footer from './../../../components/templates/manage_menubottom.vue'; // Main Footer
//
//import DeliveryLocations from './../Components/DeliveryLocations'
//
import AccountResources from './../../Account/Resources/commonfunctions.js';

//
let service = new services();

export default {
    name: 'ManageItems',
    mixins: [AccountResources],
    data () {
        return {
            users: {},
            user: {},
            business: {},
            sellpoints:{},
            categories: {},
            market_categories: {},
            market_groups: {},
            states: {},
            cities: {},
            disable_btn: false,
            validate_user_name_error:false,
            group_isset:false,
            add_sellpoint: false,
            add_business: false,
            get_flag:false,
            loading:false,
            action_loading:false,

            //messages
            validate_user_name_message: "",
            payment_successful_message:"",
            data_error_message: "",
            data_boarding_message: "",
            //
            headerdata:{
                'name':'',
            },

            //
            reset_order:false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': Footer,//MainFooter,
       // 'component-delivery-locations': DeliveryLocations
    },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },

        preset() {
            this.loading = true;
            
            //../
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.user = value;
                    //self.setProduct();
                    localforage.getItem(service.bdb_name, function(err, value) { //quick with the callback version
                        if(value != undefined) {
                            self.sellpoint = value;
                            self.headerdata.name = self.sellpoint.business_name;
                            // if(self.user.user_id == self.sellpoint.business_owner){
                                //
                                if(self.$route.params.ref && (self.$route.params.ref != '')){
                                    self.getSetProduct({},self.$route.params.ref);
                                }
                            //}
                            self.loading = false;
                        } 
                        
                    });
                }else {
                    self.loading = false;
                    self.$router.push('/login')
                }
            });
            
        },

        setGeneralGoodsCategoryProducts(category){
            this.general_goods_category = category;
            //
            this.getGeneralGoodsCategoryProducts();
            //
            this.setMenuTabInnerView('general_goods_category_products');
        },
},
created: function(){
    this.preset();
    //
    this.getGeneralGoods();
}
}



// WEBPACK FOOTER //
// ./src/pages/Manage/AddItems/script.js